// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/tabs/tabs.component.scss
// module id = 536
// module chunks = 0